import React, { useState, useEffect } from "react";
import { Modal } from 'reactstrap';

const ImageUploadDynamic = ({
  src,
  alt,
  width,
  router,
  onClosed = () => {},
}) => {
  const dimension = `${width}px`;
  const [openModal, setOpenModal]  = useState(false);

  useEffect(() => {
    window.addEventListener("message", (e) => {
      if(e.data.type === "FileModalUpload"){
        switch(e.data.action){
          case "saved":
            setOpenModal(false);
            onClosed(JSON.parse(e.data.payload));
            break;
          }
      }
    });
  }, []);

  return (
    <>
      <div
        className="avatar-wrapper"
        style={{ width: dimension, height: dimension, position: 'relative', cursor: 'pointer' }}
        onClick={() => setOpenModal(!openModal)}
      >
        {src ? (
          <img
            src={src}
            alt={alt}
            className="avatar-img"
            style={{ width: dimension, height: dimension, objectFit: 'cover', borderRadius: '50%' }}
          />
        ) : (
          <i
            className="far fa-user-circle user-photo-label me-2"
            style={{
              width: dimension,
              height: dimension,
              fontSize: dimension,
              color: '#ccc',
              textAlign: 'center',
              lineHeight: dimension
            }}
            aria-hidden="true"
          />
        )}
        <div className="avatar-upload" style={{ width: dimension, height: dimension }}>
          <i className="fas fa-edit font-size-20 upload-icon" />
        </div>
      </div>
      <Modal
        className={`modal-dinamic-table-simple`}
        isOpen={openModal}
        toggle={() => {
          setOpenModal(!openModal);
        }}
      >
        <div >
          <div className="modal-header d-flex align-items-center justify-content-between">
            <h5
              className="modal-title mt-0 font-size-24 font-w-600 text-color-azul1"
              id="myModalLabel"
            >
              Editar Imagem
            </h5>
            <button
              type="button"
              onClick={() => {
                
                setOpenModal(!openModal);
              }}
              className="btn border-0 p-0"
              data-dismiss="modal"
              aria-label="Close"
            >
              <i className="fas fa-times font-size-24 text-gray-secundary"></i>
            </button>
          </div>


          <div className="modal-body" style={{height: 550}}>

            <iframe
              id="embed-view-in-modal"
              width="100%"
              height="100%"
              src={router}
              frameborder="0"
              allowFullScreen="true"
            >
            </iframe>
          </div>
        </div>
      </Modal>

    </>
  );
}

export default ImageUploadDynamic